import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import { Buttons } from '@/components/common/buttons'
import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { CallFormFields } from '@/features/chamados/form-fields/call.form-fields'
import { Asset_SearchModal } from '@/features/patrimonios/components/asset-search-modal'
import { Asset, Call, Equipment } from '@/services/backend/config/entities'

import { ChamadoService } from '../../services/chamado.service'

interface Props {
  onSuccess: (data: Call) => void
}

interface Extended extends Asset {
  Equipment?: Equipment
}

function CreateForm({ onSuccess }: Props) {
  const [selected, setSelected] = useState<Extended>()

  const form = useForm<Parameters<typeof ChamadoService.create>[0]>({
    defaultValues: {
      description: '',
      requesterName: '',
      requesterPhone: '',
      requesterMail: '',
      files: [],
    },
  })

  const onSubmit = form.handleSubmit(async (data) => {
    if (!selected) return toast.error('Patrimônio não selecionado')

    try {
      const res = await ChamadoService.create({
        ...data,
        assetId: selected.id,
      })
      onSuccess(res)
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  })

  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="flex h-full flex-col">
        <SheetHeader>
          <SheetTitle>Novo chamado</SheetTitle>
        </SheetHeader>

        <div className="flex flex-1 flex-col gap-4 overflow-y-auto py-4">
          <div>
            <Label className="mb-0 text-sm">Patrimônio</Label>
            <div className="flex items-center gap-2">
              <Input value={selected?.Equipment?.name ?? ''} disabled />
              <Asset_SearchModal
                onSelect={setSelected}
                tipoEquipamento="EQUIPAMENTO"
                disponivel={false}
              />
            </div>
          </div>

          <CallFormFields.RequesterName />
          <CallFormFields.RequesterPhone />
          <CallFormFields.RequesterMail />
          <CallFormFields.Description />
          <CallFormFields.Evidences />
        </div>

        <SheetFooter>
          <Button type="submit">Salvar</Button>
        </SheetFooter>
      </form>
    </Form>
  )
}

export default function Component({ onSuccess }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Buttons.Add />
      </SheetTrigger>

      <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
        <CreateForm
          onSuccess={(res) => {
            setIsOpen(false)
            onSuccess(res)
          }}
        />
      </SheetContent>
    </Sheet>
  )
}
